// extracted by mini-css-extract-plugin
export default {"skills":"SkillsSection_skills__SEvNk","skills-light":"SkillsSection_skills-light__VljzA","skills-dark":"SkillsSection_skills-dark__yOaTw"};